/* eslint-disable @typescript-eslint/no-empty-function */
import {ReactElement} from "react";
import {TaskType, WorkflowTaskReferenceKeyType} from "../../__generated__/generated_types";
import {Property} from "../../contexts/properties/logic";
import WorkflowPayrollWrapper from "../../pages/payroll/WorkflowPayrollWrapper";
import {PropertyExecutiveSummaryRegularWrapper} from "../../pages/property-executive-summary/PropertyExecutiveSummaryRegularWrapper";
import Account from "../../pages/workflows/account/Account";
import AverageRent from "../../pages/workflows/operational/average-rent/AverageRent";
import EarlyTerminations from "../../pages/workflows/operational/early-terminations/EarlyTerminations";
import LeaseExpirations from "../../pages/workflows/operational/lease-expiration/LeaseExpiration";
import MonthToMonthMoveOuts from "../../pages/workflows/operational/month-to-month-move-outs/MonthToMonthMoveOuts";
import MoveOutRates from "../../pages/workflows/operational/move-outs/MoveOutRates";
import OccupancyManager from "../../pages/workflows/operational/occupancy-manager/OccupancyManager";
import OccupancyRates from "../../pages/workflows/operational/occupancy-rates/OccupancyRates";
import RenewalRates from "../../pages/workflows/operational/renewal-rates/RenewalRates";
import RenewalRatios from "../../pages/workflows/operational/renewal-ratios/RenewalRatios";
import {TUserWorkflowTask} from "./logic/useUserWorkflow";


export interface IUserWorkflowPageDeciderProps {
    task: TUserWorkflowTask;
    versionType: string;
    property: Property;
}

export function UserWorkflowPageDecider({task, versionType, property}: IUserWorkflowPageDeciderProps): ReactElement {
    if (task.taskType == TaskType.Account && task.accountId) {
        return (
            <Account
                budgetYear={property.budgetYear}
                onNextClick={() => {}}
                onPreviousClick={() => {}}
                accountId={task.accountId}
                type={versionType}
                inUserWorkflow
                key="account-node"
            />
        );
    } else if (task.taskType == TaskType.Revenue && task.referenceKey) {
        switch (task.referenceKey) {
            case WorkflowTaskReferenceKeyType.AvgMarketRents:
                return <AverageRent onNextClick={() => {}} onPreviousClick={() => {}} inUserWorkflow />;
            case WorkflowTaskReferenceKeyType.Expirations:
                return <LeaseExpirations onNextClick={() => {}} onPreviousClick={() => {}} inUserWorkflow />;
            case WorkflowTaskReferenceKeyType.RenewalsRatio:
                return <RenewalRatios onNextClick={() => {}} onPreviousClick={() => {}} inUserWorkflow />;
            case WorkflowTaskReferenceKeyType.RenewalsRate:
                return <RenewalRates onNextClick={() => {}} onPreviousClick={() => {}} inUserWorkflow />;
            case WorkflowTaskReferenceKeyType.MoveOuts:
                return <MoveOutRates onNextClick={() => {}} onPreviousClick={() => {}} inUserWorkflow />;
            case WorkflowTaskReferenceKeyType.EarlyTerms:
                return <EarlyTerminations onNextClick={() => {}} onPreviousClick={() => {}} inUserWorkflow />;
            case WorkflowTaskReferenceKeyType.MonthToMonth:
                return <MonthToMonthMoveOuts onNextClick={() => {}} onPreviousClick={() => {}} inUserWorkflow />;
            case WorkflowTaskReferenceKeyType.Occupancy:
                return <OccupancyRates onNextClick={() => {}} onPreviousClick={() => {}} inUserWorkflow />;
            case WorkflowTaskReferenceKeyType.OccupancyManager:
                return <OccupancyManager key={versionType} onNextClick={() => {}} onPreviousClick={() => {}} inUserWorkflow />;
            default:
                return <></>;
        }
    } else if (task.taskType == TaskType.Custom && task.referenceKey) {
        switch (task.referenceKey) {
            case WorkflowTaskReferenceKeyType.Payroll:
                return <WorkflowPayrollWrapper property={property} />;
            case WorkflowTaskReferenceKeyType.ExecutiveSummary:
                return <PropertyExecutiveSummaryRegularWrapper />;
            default:
                return <></>;
        }
    }

    return <></>;
}
